import { useState, useEffect } from "react";
import TopPageTitle from "../../../components/TopPageTitle/TopPageTitle";
import * as styled from "./LessonPayment.styled";
import { getAllStudents } from "../../../helpers/getAllStudents";
import { useNavigate } from "react-router-dom";
import axios from "../../../axios";
import { PagesWrapper } from "../../../styles/components/PagesWrapper.styled";

const packages = [8, 16, 32, 50];

function LessonPayment({ adminInfo }) {
  const [students, setStudents] = useState([]);
  const [filteredStudents, setFilteredStudents] = useState([]);
  const [selectedId, setSelectedId] = useState(null);
  const [status, setStatus] = useState({ success: null, id: null });
  const [search, setSearch] = useState("");
  const navigate = useNavigate();

  const getStudents = () => {
    getAllStudents().then((students) => {
      const filtered = students.map(
        ({
          _id,
          name,
          totalLessons,
          studentId,
          ageGroup,
          accessType,
          lessonPackage,
          isPaused,
        }) => ({
          _id,
          name,
          totalLessons,
          studentId,
          ageGroup,
          accessType,
          lessonPackage,
          isPaused,
        })
      );
      setStudents(filtered);
      setFilteredStudents(filtered);
    });
  };
  useEffect(() => {
    getStudents();
  }, []);

  useEffect(() => {
    const searchTerm = search.toLowerCase();
    setFilteredStudents(
      students.filter(
        ({ name, studentId, accessType }) =>
          (adminInfo.accessType === "all" ||
            accessType === adminInfo.accessType) &&
          (name.toLowerCase().includes(searchTerm) ||
            studentId.toLowerCase().includes(searchTerm))
      )
    );
  }, [search, students, adminInfo.accessType]);

  const updatePackage = async (lessons, id) => {
    try {
      await axios.post(`students/update-total/${id}/${lessons}`);
      setStatus({ success: true, id });
      getStudents();
      setSelectedId(null);
      setTimeout(() => setStatus({ success: null, id: null }), 2000);
    } catch {
      setStatus({ success: false, id });
      setTimeout(() => setStatus({ success: null, id: null }), 2000);
    }
  };

  const handleChangeByOne = async (id, delta) => {
    const student = students.find((s) => s._id === id);
    if (!student) return;
    const newTotal = Math.max(0, student.totalLessons + delta);
    await updatePackage(newTotal, id);
  };

  return (
    <PagesWrapper>
      <TopPageTitle value={"Оплата учнів"} />
      <styled.TopWrapper>
        <styled.SearchInput
          placeholder="Пошук за ім'ям або ID..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
        <styled.TotalStudents>
          {
            filteredStudents.filter(
              ({ studentId, isPaused }) =>
                !["228", "17", "288"].includes(studentId) &&
                (isPaused === undefined || isPaused === false)
            ).length
          }{" "}
          students
        </styled.TotalStudents>
      </styled.TopWrapper>

      <styled.PaymentContainer>
        {filteredStudents
          .sort((a, b) => a.totalLessons - b.totalLessons)
          .map(
            ({
              _id,
              name,
              studentId,
              totalLessons,
              ageGroup,
              lessonPackage,
              isPaused,
            }) => {
              const isOpen = selectedId === _id;

              return (
                <styled.StudentPaymentCard
                  key={_id}
                  isTotalZero={totalLessons <= 0}
                  colorLevel={
                    totalLessons <= 0
                      ? "low"
                      : totalLessons <= 1
                      ? "medium"
                      : "high"
                  }
                  isPaused={isPaused}
                  animate={status.id === _id}
                  onClick={() => setSelectedId(isOpen ? null : _id)}
                >
                  <styled.Header>
                    <styled.StudentName>{name}</styled.StudentName>
                    <styled.MoveItem
                      onClick={() =>
                        navigate(`/admin/ourstudents/${ageGroup}/${_id}`)
                      }
                    >
                      Переглянути
                    </styled.MoveItem>
                  </styled.Header>
                  <styled.StudentID>ID: {studentId}</styled.StudentID>
                  {isPaused && (
                    <styled.StudentID>Призупинив заняття</styled.StudentID>
                  )}

                  <styled.ProgressBarContainer>
                    <styled.ProgressBar
                      value={totalLessons}
                      max={lessonPackage || 50}
                    />
                    <span>{totalLessons} занять</span>
                  </styled.ProgressBarContainer>

                  <styled.Actions>
                    <styled.ChangeButton
                      onClick={(e) => {
                        e.stopPropagation();
                        handleChangeByOne(_id, -1);
                      }}
                    >
                      -1
                    </styled.ChangeButton>
                    <styled.ChangeButton
                      onClick={(e) => {
                        e.stopPropagation();
                        handleChangeByOne(_id, 1);
                      }}
                    >
                      +1
                    </styled.ChangeButton>
                  </styled.Actions>

                  {isOpen && (
                    <styled.PackagesList>
                      {packages.map((val) => (
                        <styled.PackageButton
                          key={val}
                          onClick={(e) => {
                            e.stopPropagation();
                            updatePackage(val, _id);
                          }}
                        >
                          {val} уроків
                        </styled.PackageButton>
                      ))}
                    </styled.PackagesList>
                  )}

                  {status.id === _id && status.success === true && (
                    <styled.SuccessText>✅ Успішно оновлено</styled.SuccessText>
                  )}
                  {status.id === _id && status.success === false && (
                    <styled.ErrorText>❌ Помилка оновлення</styled.ErrorText>
                  )}
                </styled.StudentPaymentCard>
              );
            }
          )}
      </styled.PaymentContainer>
    </PagesWrapper>
  );
}

export default LessonPayment;
